import { createSlice } from "@reduxjs/toolkit";

const fundSlice = createSlice({
    name: "fund",

    initialState: {
        isLoading: false,

        fundList: [],

        currentFund: {},
    },

    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },

        setFundList(state, action) {
            state.fundList = action.payload;
        },

        setCurrentFund(state, action) {
            state.currentFund = action.payload;
        },
    },
});

export const {
    setIsLoading,
    setFundList,
    setCurrentFund,
} = fundSlice.actions;

export default fundSlice.reducer;